export default "__VITE_ASSET__DlcPxwer__"